{
  "en": {
    "milestone_unit": {
      "actions": {
        "change_milestone": "Change phase",
        "reset_columns": "Reset columns"
      },
      "labels": {
        "columns": "Columns",
        "milestone": "Please select a new phase",
        "no_results": "No units found"
      }
    }
  }
}
